import Header from './Header';
import Testimonials from './Testimonials';
import Offres from './Offres';
import Timeline from './Timeline';
import BlueBox from './BlueBox';
import OffresPath from './OffresPath';
import Home from './Home';
import ArticleCarousel from './ArticleCarousel';
import OffreToggle from './OffreToggle';
import Realisations from './Realisations';
import Chiffre from './Chiffre';
import LogosMarquee from './LogosMarquee';
import StaggeredOpacity from './StaggeredOpacity';
import Parallax from './Parallax';
import FormationToggle from './FormationToggle';


const components = {
  Header,
  Testimonials,
  Offres,
  Timeline,
  BlueBox,
  OffresPath,
  Home,
  ArticleCarousel,
  OffreToggle,
  Realisations,
  Chiffre,
  LogosMarquee,
  StaggeredOpacity,
  Parallax,
  FormationToggle,
}


export default components;
